export class MeiliSearchError extends Error {
    name = "MeiliSearchError";
}
//# sourceMappingURL=meilisearch-error.js.map